// @ts-nocheck

/**
 * * `create` - create
 * `update` - update
 * `delete` - delete
 */
export type OpEnum = typeof OpEnum[keyof typeof OpEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OpEnum = {
  create: "create",
  update: "update",
  delete: "delete",
} as const;
